import {fromEvent, Observable} from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import Frame from '../Frame';

/**
 * Creates an observable stream from the `exitfullscreen` event on
 * the `window`, only emitting when the frame is fullscreened.
 */

const createExitFullscreenStream = (
    target: EventTarget,
    frameStoreUpdate$: Observable<Frame>
): Observable<void> =>
    fromEvent(target, 'exitfullscreen')
        .pipe(
            withLatestFrom(frameStoreUpdate$),
            filter(([_, latestFrameValue]) => latestFrameValue.isFrameFullscreened),
            map(() => void 0)
        );

export default createExitFullscreenStream;